import { RPCs } from "../../../services/rpc.js";
import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { useRegionContext } from "../../Regions/contexts/RegionContext.js";
import { UserNames } from "../../Users/shared/UserNames.js";
import { RefsByTypeTitles } from "../../shared/RefsByTypeTitles/index.js";
import { useMemo } from "react";
import { Button, ColorCircle, ColorSquare, Tag } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { castArray } from "lodash-es";
import { atom, useAtom } from "jotai";
//#region src/modules/Reports/shared/SelectReport.tsx
var activeGroupAtom = atom("open");
var SingleAndListItem = ({ authors, date, refsByType, reportType, status }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "inline-flex w-full items-center justify-between",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [
				/* @__PURE__ */ jsxs("div", { children: [!!reportType.color && /* @__PURE__ */ jsx(ColorSquare, {
					color: reportType.color,
					marginRight: true
				}), /* @__PURE__ */ jsx("span", {
					className: "text-color-subtle truncate text-sm",
					children: reportType.name
				})] }),
				/* @__PURE__ */ jsx(UserNames, { userIds: authors.map((a) => a.id) }),
				!!refsByType && /* @__PURE__ */ jsx("div", {
					className: "text-color-subtle truncate text-sm",
					children: /* @__PURE__ */ jsx(RefsByTypeTitles, {
						refsByType,
						showDetails: false
					})
				})
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "gap-y-xxs flex flex-col",
			children: [/* @__PURE__ */ jsx(DateTime$1, {
				mode: "datetime",
				timestamp: date
			}), !!status && /* @__PURE__ */ jsx(Tag, {
				backgroundColor: status.color,
				value: status.title
			})]
		})]
	});
};
var SelectedMulti = ({ reportType, status, title }, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "gap-x-sm px-sm flex max-w-full items-center text-sm",
		children: [!!status.color && /* @__PURE__ */ jsx(ColorCircle, { color: status.color }), /* @__PURE__ */ jsxs("div", {
			className: "truncate",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle truncate",
				children: reportType.name
			}), /* @__PURE__ */ jsx("div", {
				className: "truncate",
				children: title
			})]
		})]
	})
});
var MenuList = (props) => {
	const [activeGroup, setActiveGroup] = useAtom(activeGroupAtom);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
		className: "gap-x-xs bg-surface-strong p-xs sticky top-0 flex rounded-t",
		children: [
			/* @__PURE__ */ jsx(Button, {
				className: classnames({ "bg-main-faded": activeGroup === "open" }, "flex-1"),
				disabled: activeGroup === "open",
				fullWidth: true,
				onClick: () => {
					if (setActiveGroup) setActiveGroup("open");
				},
				subtle: true,
				variant: "main",
				children: "Open"
			}),
			/* @__PURE__ */ jsx(Button, {
				className: classnames({ "bg-positive-faded": activeGroup === "review" }, "flex-1"),
				disabled: activeGroup === "review",
				onClick: () => {
					if (setActiveGroup) setActiveGroup("review");
				},
				subtle: true,
				variant: "positive",
				children: "Review"
			}),
			/* @__PURE__ */ jsx(Button, {
				className: classnames({ "bg-neutral-faded": activeGroup === "closed" }, "flex-1"),
				disabled: activeGroup === "closed",
				onClick: () => {
					if (setActiveGroup) setActiveGroup("closed");
				},
				subtle: true,
				variant: "neutral",
				children: "Closed"
			})
		]
	}), props.children] });
};
var responseOptionsExtractor = (data) => data?.reports;
function SelectReport({ authorUserIdsFilter, fromDate, idFilter, limit = 15, multi, refs, reportTypeIdsFilter, statusIdFilter, toDate, value, ...atalayaSelectProps }) {
	const [activeGroup] = useAtom(activeGroupAtom);
	const regionCtx = useRegionContext();
	useMemo(() => value ? { idFilter: castArray(value) } : void 0, [value]);
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: SingleAndListItem,
		RenderMenuList: MenuList,
		RenderSelectedSingle: SingleAndListItem,
		RenderSelectedMulti: SelectedMulti,
		args: {
			authorUserIdsFilter,
			fromDate,
			idFilter,
			refs,
			regionIds: regionCtx ? [regionCtx?.regionId] : void 0,
			reportTypeIdsFilter,
			state: activeGroup,
			statusIdFilter,
			toDate
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ title }) => title,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Reports.GetReportsList.v1,
		requestFilterProp: "idFilter",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
}
//#endregion
export { SelectReport };

//# sourceMappingURL=SelectReport.js.map